import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { open, close } from '../../../../helpers';

const SidebarFilter = ({ filter, pins, onPinSelect }) => {
  const contentRef = useRef();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!contentRef.current) return;
    if (isOpen) {
      open({ element: contentRef.current });
    } else {
      close({ element: contentRef.current });
    }
  }, [isOpen]);

  return (
    <div
      key={filter.filterId}
      className={classNames('interactive-map-module__sidebar-filter', {
        'interactive-map-module__sidebar-filter--open': isOpen
      })}
    >
      <button
        className="interactive-map-module__sidebar-filter-trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        {filter.name}
        <svg viewBox={isOpen ? '0 0 10 2' : '0 0 10 10'}>
          <title>filter trigger</title>
          <use xlinkHref={isOpen ? '#minus' : '#plus'} />
        </svg>
      </button>
      <div
        className="interactive-map-module__sidebar-filter-content"
        ref={contentRef}
      >
        <ul>
          {pins.map((pin, i) => (
            <li key={i}>
              <a
                href={pin.linkUrl}
                target={pin.linkTarget}
                onClick={e => onPinSelect(e, pin)}
              >
                {pin.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

SidebarFilter.propTypes = {
  filter: PropTypes.object.isRequired,
  pins: PropTypes.array.isRequired,
  onPinSelect: PropTypes.func.isRequired
};

export default SidebarFilter;
